<template>
	<div>
		<SelectFavoriteAppsMenu :nudge-right="7" :nudge-bottom="7" hidePrevious>
			<template #activator="{ value }">
				<AppTooltip text="Add apps">
					<div :class="{ active: value }" class="create-new-button flex-centerize">
						<SIcon name="create-new-placement-plus" />
					</div>
				</AppTooltip>
			</template>
		</SelectFavoriteAppsMenu>
	</div>
</template>

<script>
import SelectFavoriteAppsMenu from '@/components/SelectFavoriteApps/SelectFavoriteAppsMenu.vue';
export default {
	name: 'AddOnsSelectFavoriteApps',
	components: {
		SelectFavoriteAppsMenu,
	},
};
</script>

<style lang="scss" scoped>
.create-new-button {
	height: 14px;
	width: 14px;
	cursor: pointer;
	border-radius: 50%;
	&.active,
	&:hover {
		background: #f2f2f2;
		border: 1px solid var(--border-color);
	}
}
</style>
